<micro-lookup domain="smsc" obj="smscConnections" url="/smsc/smscConnections" [key]="smscConnectionId" [link]="link"></micro-lookup>
